// extracted by mini-css-extract-plugin
export default {"child1":"styles_child1__GIv16","child2":"styles_child2__uJ2L3","parent":"styles_parent__2nAz7"};